module.exports = __webpack_public_path__ + "img/farizon.130c5209.jpg";